var render = function render(){var _vm=this,_c=_vm._self._c;return _c('centered',{attrs:{"width":600}},[_c('owners-crud')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }